import type { Value } from './types';
export const lifecycleUnits = ['days', 'months', 'years'] as const;
export type LifecycleUnit = typeof lifecycleUnits[number];
export function lifecycleUnit(value: Value | undefined): LifecycleUnit | null {
  const unit = String(value ?? '').trim().toLowerCase();
  if (['day', 'days', 'd'].includes(unit)) return 'days';
  if (['month', 'months', 'mo'].includes(unit)) return 'months';
  if (['year', 'years', 'y'].includes(unit)) return 'years';
  return null;
}
/** Mirrors the existing lot-date calendar convention: integral units, clamped month ends. */
export function lifecycleMilestone(date: string, value: Value | undefined, rawUnit: Value | undefined): string | null {
  const unit = lifecycleUnit(rawUnit);
  const amount = value == null || value === '' || typeof value === 'boolean' ? NaN : Number(value);
  const parsed = new Date(`${date}T00:00:00Z`);
  if (!unit || !Number.isInteger(amount) || amount < 0 || !Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return null;
  if (unit === 'days') parsed.setUTCDate(parsed.getUTCDate() + amount);
  else {
    const day = parsed.getUTCDate();
    parsed.setUTCDate(1);
    parsed.setUTCMonth(parsed.getUTCMonth() + amount * (unit === 'years' ? 12 : 1));
    const last = new Date(Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth() + 1, 0)).getUTCDate();
    parsed.setUTCDate(Math.min(day, last));
  }
  return Number.isFinite(parsed.getTime()) ? `${parsed.toISOString().slice(0, 10)} 00:00 UTC` : null;
}
